import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa'
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import DonateModal from './DonateModal'

const navigation = {
  main: [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Programs', href: '/programs' },
    { name: 'Media & News', href: '/media' },
    { name: 'Reports', href: '/reports' },
    { name: 'Contact', href: '/contact' },
  ],
  social: [
    {
      name: 'Facebook',
      href: '#',
      icon: FaFacebook,
    },
    {
      name: 'Twitter',
      href: '#',
      icon: FaTwitter,
    },
    {
      name: 'Instagram',
      href: '#',
      icon: FaInstagram,
    },
    {
      name: 'LinkedIn',
      href: '#',
      icon: FaLinkedin,
    },
  ],
}

function Footer() {
  const [donateModalOpen, setDonateModalOpen] = useState(false)

  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="container py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div>
              <h3 className="text-xl font-bold mb-4">PACIEH</h3>
              <p className="text-gray-400 mb-4">
                Pan-African Community Initiative on Education and Health — transforming lives through sustainable community-driven interventions since 2013.
              </p>
              <div className="space-y-2">
                <a 
                  href="tel:+2348032729271" 
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <PhoneIcon className="h-5 w-5 mr-2" />
                  +234 803 272 9271
                </a>
                <a
                  href="mailto:paciehng@gmail.com"
                  className="flex items-center text-gray-400 hover:text-white"
                >
                  <EnvelopeIcon className="h-5 w-5 mr-2" />
                  paciehng@gmail.com
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/programs" className="text-gray-400 hover:text-white transition-colors">
                    Our Programs
                  </Link>
                </li>
                <li>
                  <Link to="/goodwill-medical" className="text-gray-400 hover:text-white transition-colors">
                    Goodwill Medical Centre
                  </Link>
                </li>
                <li>
                  <Link to="/team" className="text-gray-400 hover:text-white transition-colors">
                    Leadership & Team
                  </Link>
                </li>
                <li>
                  <Link to="/reports" className="text-gray-400 hover:text-white transition-colors">
                    Reports & Publications
                  </Link>
                </li>
                <li>
                  <Link to="/gallery" className="text-gray-400 hover:text-white transition-colors">
                    Impact Gallery
                  </Link>
                </li>
              </ul>
            </div>

            {/* Get Involved */}
            <div>
              <h3 className="text-xl font-bold mb-4">Get Involved</h3>
              <ul className="space-y-2">
                <li>
                  <button
                    type="button"
                    onClick={() => setDonateModalOpen(true)}
                    className="text-pacieh-green hover:underline font-semibold transition-colors"
                  >
                    Donate to PACIEH
                  </button>
                </li>
                <li>
                  <a 
                    href="https://forms.gle/bss8TuKU6U9xXCZ89" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Volunteer Application
                  </a>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                    Partner With Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Social Links */}
            <div>
              <h3 className="text-xl font-bold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/people/Pan-African-Community-Initiative-on-Education-and-Health-Pacieh/100064950510004/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Facebook
                </a>
                <a 
                  href="https://x.com/paciehnigeria" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  X (Twitter)
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Credits */}
          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} PACIEH. All rights reserved.
              </p>
              <div className="text-gray-400 text-sm md:text-right">
                <p>
                  Designed and Developed by NIUXVERSE SOLUTIONS
                </p>
                <p className="mt-1">
                  Contact: +234 811 060 7341 / +234 813 397 9105
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Global Donation Modal */}
      <DonateModal
        isOpen={donateModalOpen}
        onClose={() => setDonateModalOpen(false)}
      />
    </>
  )
}

export default Footer 